// מאגר הקבוצות המלא — משמש בטופס ההצטרפות, טופס ההזמנה וטאב "יוסטאר מצלמים"
const FOOTBALL_CLUBS = [
  'אגמים נתניה','אום אל פחם','איחוד בני שפרעם','איחוד ג\'סר א-זרקא','איחוד כפר קאסם','איחוד מגאר',
  'אל-חמס נאעורה','אל-חמס פוריידיס','אריאל','באקה אל-גרבייה',
  'בית"ר ירושלים','בית"ר מודיעין','בית"ר נורד ירושלים','בית"ר עפולה','בית"ר רמת גן','בית"ר תל אביב',
  'בית שאן','בני יהודה תל אביב','בני נצרת','בני סח\'נין',
  'גבעת שמואל','גבעתיים',
  'הפועל אום אל פחם','הפועל אור עקיבא','הפועל אחי נצרת','הפועל אילת','הפועל אירוני ראשון לציון',
  'הפועל אכסאל','הפועל אלעד','הפועל אריאל','הפועל אשדוד','הפועל אשקלון',
  'הפועל באקה','הפועל באר שבע','הפועל בני ברק','הפועל בני לוד','הפועל בנימינה','הפועל בת ים',
  'הפועל גבעת שמואל','הפועל גבעתיים','הפועל גדרה','הפועל גן יבנה',
  'הפועל דימונה','הפועל הרצליה','הפועל חדרה','הפועל חולון','הפועל חיפה',
  'הפועל טבריה','הפועל טייבה','הפועל טירה','הפועל טירת כרמל',
  'הפועל יבנה','הפועל יהוד','הפועל יוקנעם','הפועל יפו','הפועל ירושלים','הפועל ירכא',
  'הפועל כפר סבא','הפועל כפר שלם','הפועל כפר קאסם','הפועל כרמיאל',
  'הפועל לוד','הפועל מגדל העמק','הפועל מודיעין','הפועל נהריה','הפועל נוף הגליל',
  'הפועל נצרת','הפועל נשר','הפועל נתניה',
  'הפועל עכו','הפועל עפולה','הפועל ערד','הפועל פתח תקווה',
  'הפועל צפת','הפועל קטמון ירושלים','הפועל קריית אונו','הפועל קריית גת',
  'הפועל קריית מוצקין','הפועל קריית שמונה',
  'הפועל ראשון לציון','הפועל רחובות','הפועל רמלה','הפועל רמת גן','הפועל רמת השרון',
  'הפועל שפרעם','הפועל תל אביב','הפועל תל מונד','הפועל תמרה',
  'זכרון יעקב','כפר כנא','כפר מנדא','כפר קרע',
  'מ.ס. אשדוד','מ.ס. כביר','מ.ס. כנעאן',
  'מכבי אום אל פחם','מכבי אור יהודה','מכבי אחי נצרת','מכבי אחיעזר','מכבי אילת',
  'מכבי אירוני ראשון לציון','מכבי אכסאל','מכבי אלעד','מכבי אריאל','מכבי אשדוד','מכבי אשקלון',
  'מכבי בית שאן','מכבי בית שמש','מכבי בני ברק','מכבי בת ים',
  'מכבי גדרה','מכבי גן יבנה','מכבי גני תקווה',
  'מכבי הרצליה','מכבי זכרון יעקב','מכבי חדרה','מכבי חולון','מכבי חיפה',
  'מכבי טבריה','מכבי טייבה','מכבי טירה','מכבי טירת כרמל',
  'מכבי יבנה','מכבי יהוד','מכבי יוקנעם','מכבי יפו','מכבי ירכא',
  'מכבי כפר בר','מכבי כפר ברא','מכבי כפר כנא','מכבי כפר מנדא','מכבי כפר סבא','מכבי כפר קאסם',
  'מכבי כרמיאל','מכבי לוד','מכבי מגדל העמק','מכבי מגדל שמס','מכבי מודיעין',
  'מכבי נהריה','מכבי נוף הגליל','מכבי נצרת','מכבי נשר','מכבי נתניה',
  'מכבי עכו','מכבי עפולה','מכבי פתח תקווה',
  'מכבי צפת','מכבי קטמון ירושלים','מכבי קריית גת','מכבי קריית מוצקין','מכבי קריית שמונה',
  'מכבי ראשון לציון','מכבי רחובות','מכבי רמלה','מכבי רמת גן','מכבי רמת השרון',
  'מכבי שפרעם','מכבי תל אביב','מכבי תמרה',
  'עירוני אשדוד','עירוני טבריה','עירוני ירושלים','עירוני כנרות','עירוני קריית שמונה','עירוני רמת השרון',
  'פועלי נצרת','ריינה','שמשון תל אביב',
].sort((a, b) => a.localeCompare(b, 'he'));

export default FOOTBALL_CLUBS;
